import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";

import type { DipSchemaNodeData } from "~/features/dataImportProjects/types";
import { cn } from "~/lib/utils";

const KIND_CLASS: Record<DipSchemaNodeData["kind"], string> = {
  main: "border-[#1B4F86] bg-[#1B4F86] [&_strong]:text-white [&_span]:text-[#DCEEFB]",
  relation: "border-[#7CB7E8] bg-bg-surface",
  entity: "border-[#7CB7E8] bg-[#DCEEFB]",
};

export function DipSchemaNode({ data }: NodeProps<Node<DipSchemaNodeData>>) {
  const clickable = typeof data.detailPath === "string" && data.detailPath.length > 0;
  return (
    <>
      <Handle type="target" position={Position.Left} className="!h-2 !w-2 !border-none !bg-primary-300" />
      <div
        className={cn(
          "flex w-[230px] flex-col justify-center rounded-[var(--radius-md)] border px-3 py-2.5 transition-colors",
          KIND_CLASS[data.kind],
          clickable && "cursor-pointer hover:border-primary-500",
        )}
      >
        <strong className="truncate text-14-bold text-fg-1">{data.title}</strong>
        {data.category && <span className="truncate text-12-regular text-fg-3">{data.category}</span>}
      </div>
      <Handle type="source" position={Position.Right} className="!h-2 !w-2 !border-none !bg-primary-300" />
    </>
  );
}
